export default __webpack_public_path__ + "static/media/40.5cf02881.jpg";